import React from "react";
import "../Css/Videos.css";

const videos = [
  {
    id: 1,
    title: "Importance of Exam Strategies",
    url: "https://www.youtube.com/embed/W_fOjtPB_wg",
  },
  {
    id: 2,
    title: "Simultaneous Equilibrium",
    url: "https://www.youtube.com/embed/kPt-9FJWmjw",
  },
  {
    id: 3,
    title: "Walking Friction",
    url: "https://www.youtube.com/embed/930CkmLY9KI",
  },
  {
    id: 4,
    title: "Direction of Rolling Friction",
    url: "https://www.youtube.com/embed/7eKdVqztxk4",
  },
  {
    id: 5,
    title: "Refraction class 10",
    url: "https://www.youtube.com/embed/0oYhmbKka8c",
  },
  {
    id: 6,
    title: "Direction of Rolling Friction",
    url: "https://www.youtube.com/embed/hG8drFBh1fM",
  },
  {
    id: 7,
    title: "Cylinder Rolling Down An Inclined Plane",
    url: "https://www.youtube.com/embed/EPhamLG6-pk",
  },
  {
    id: 8,
    title: "i to the power i",
    url: "https://www.youtube.com/embed/vcza8BV15Kk",
  },
  {
    id: 9,
    title: "JEE Results and Boards",
    url: "https://www.youtube.com/embed/kUBfJN7MHCU",
  },
  {
    id: 10,
    title: "5 Ways to Improve Focus, Productivity and Study Quality",
    url: "https://www.youtube.com/embed/2mNBvA3R1uI",
  },
];

const EducationalVideos = () => {
  return (
    <section className="videos-section">
      <h2 className="videos-title">Educational Videos</h2>

      <div className="videos-grid">
        {videos.map((video) => (
          <div className="video-card" key={video.id}>
            <div className="video-wrapper">
              <iframe
                src={video.url}
                title={video.title}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EducationalVideos;
